import { useContext } from 'react'
import { PageViewContext } from '../providers'

export const usePageView = () => {
  return useContext(PageViewContext)
}
